// 判断环境
export const isMain = false
// 自己 /api
const windowHost = window.location.origin
let pattern =
  /^(http:\/\/localhost|http:\/\/192\.168|https:\/\/localhost|https:\/\/192\.168|file:\/\/*)/i
export let baseUrl: string = isMain
  ? windowHost
  : // 'https://testmaingame.genesistown.io' + '/user' 
  // 'http://223.26.78.105:80'
  '/'